/**
 * Generated by orval v7.8.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

export enum ProspectReplyLabel {
  optout = 'optout',
  interested = 'interested',
  question = 'question',
  not_relevant = 'not_relevant',
  other = 'other'
}
